import { createAction } from 'redux-actions';
import { SET_LOADED, SET_SIDEBAR_OPEN, SET_THEME_MODE } from './types';

export const setLoaded = createAction(SET_LOADED);
export const setSidebarOpen = createAction(SET_SIDEBAR_OPEN);
export const setThemeMode = createAction(SET_THEME_MODE);

export const toggleThemeMode = () => (dispatch, getState) => {
  const current = getState().app.themeMode;
  dispatch(setThemeMode(current === 'dark' ? 'light' : 'dark'));
};

export const load = () => (dispatch) => {
  // .then(() => dispatch(setLoaded()))
};

